module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('img', {
    attrs: {
      "alt": "inline-image",
      "src": "images/flr1.jpg"
    }
  }), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EN")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HANKS")]), _vm._v(" for loving me, leading me, and letting me share my message. You’re the ink in my pen. Lindsay, Cole, and Cade: My sweet kids, I love you so. Thanks for having love that always hopes and always perseveres, even when I’m not at my best (but boys, you know it makes it worse when you sing the Control Girl song). May you always fly to Jesus with your every need. My parents: I’m so proud to claim you. Dad, you’re the kind of father I wish every girl had. Mom, your gracious way of serving, giving, and loving inspires me to be a Jesus Girl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chris and Jamie Brauns: Your friendship is a gift. Chris, you may deserve credit for first discovering my inner Control Girl with a McDonald’s cup in hand. Thanks for inspiring me to write and investing in me for so many years. Jamie, thanks for helping me sort out life while I sort laundry. This book, in large part, is a recap of our conversations. Jackie VanDyke: From the junior high bus to trails and treadmills, we’re on this journey together. Your input, both on what the Bible says and how to live its message, is such a gift to me. Angela Gebhard: Thanks for loving me and my family. Your love for Jesus makes me want to love him more. My favorite visits with you are when we cry. Cindy Bultema: Your confetti-like encouragement is catching. Thanks for taking me under your wing and inspiring me to keep going. Del and Deb Fehsenfeld: God has blessed me so much with your encouragement and writing guidance over the years.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("And to the “Prayeriors,” you powerful women of prayer (plus a couple of men), my partners in the fight: Mom and Dad, Ken, Karen G., Aunt Jo, Jamie, Cindy, Jackie V., Angela, Renee, Ingrid, Michelle L., Darcie, Dawn, Deb S., Marie, Missy, Jessica, Deb F., Cheryl, Stacy, Lori, Mara, Nicole, Kristi, Beth, Brenda, Hilma, Sue, Wendi, Tabby, Brie, Lindsay, Hannah, ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Sarah, Renell, Jackie S., Amy, Jocelyn, Michelle G., Ruth, Carrie, and Lisa—thank you! Your faithful prayers and encouragement have more than doubled my armor.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeff Manion, Dan Wright, and Marie Mossner: Thanks for your ministry to our church and for investing in me personally. Thanks to my agent, Karen Neumair, for seeing the potential and encouraging me every step of the twisty-turn way. I am so thankful for Credo and you. And I’m so honored to work with the wonderful people at Kregel Publications. Janyre: I’m blessed not only to have you edit my work but to have gained a dear friend in the process. Sarah, Micah, Katherine, and Noelle: I am so thankful for your keen insight and gracious help. In addition, I’m grateful for the input and guidance from my writer and speaker friends, Paula Marsteller, Erin Davis, Alice Daniels, Rachel Norton, Susie Finkbeiner, and Susan Tebos. Thanks to those who have shared their stories with me and participated in my forums. You know who you are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And most of all, thanks to Jesus, whose love has washed me clean and whose Spirit lays down the arrows and compels me forward in joy. My hope is to please you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c7283e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Acknowledgments.vue
// module id = 72
// module chunks = 0